import script from "./share-company-update-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./share-company-update-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__